import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-close',
  templateUrl: './icon-close.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCloseComponent {}
